<input #fileInput class="file-input" type="file" (change)="onFileChange($event.target.files)" [attr.accept]="accept">
<button mat-flat-button color="primary" (click)="fileInput.click()">{{ label }}</button>
{{ fileName }}
